import { v4 as uuid4 } from "uuid";
import { xml } from "@xmpp/client";
import { store } from "src/store/store";
import { encodeCurrentState } from "src/modules/deviceStats-protobuf/index";
import { getEnvironmentVariable } from "src/utils/environment";
import * as selectors from "src/modules/activity-log/duck/selectors";

const log = window.require("electron-log");
const os = window.require("os");

const FIFTEEN_MINUTES = 900000;

export class ActivityService {
  xmpp;
  getPresence;
  startDate = new Date();
  state = "idle"; // idle|running

  initialize = (messenger) => {
    this.xmpp = messenger.xmpp;
    this.getPresence = () => messenger.presence;
    if (this.state === "idle") this.start();
  };

  start = () => {
    this.state = "running";
    const sendCurrentState = async () => {
      // deprecated API
      const memoryUsed =
        os?.freemem?.() ||
        performance?.memory?.jsHeapSizeLimit -
          performance?.memory?.usedJSHeapSize ||
        0;

      // experimental API
      const networkType =
        navigator.connection?.type ||
        navigator.connection?.effectiveType ||
        "unknown";

      const battery = await navigator.getBattery?.();
      const uptime = new Date().getTime() - this.startDate.getTime();

      const currentState = {
        memoryUsed,
        networkType,
        signalStrength: -1,
        batteryLevel: Math.round((battery?.level || 1) * 100),
        presence: this.getPresence(),
        uptime,
        availableDiskSpace: -1,
        additionalData: JSON.stringify({
          pendingAudioEvents: selectors.getPendingAudioEvents(store.getState())
            .length,
          pendingCaptureEvents: selectors.getPendingCaptureEvents(
            store.getState()
          ).length,
          pendingMonitorings: Object.values(
            selectors.getMonitorings(store.getState())
          ).filter((monitoring) => !monitoring.isStructureUploaded).length
        })
      };

      const encoded = encodeCurrentState(currentState);
      const uuid = uuid4();

      const message = xml(
        "iq",
        {
          type: "set",
          to: getEnvironmentVariable("XMPP_DOMAIN"),
          id: uuid
        },
        xml("data", { xmlns: "tappytaps:iq:setdevicestats" }, encoded)
      );
      const response = await this.xmpp.iqCaller.request(message, 3000);
      if (!response) log.error(`Didnt receive response from Activity IQ`);
      setTimeout(sendCurrentState, FIFTEEN_MINUTES);
    };
    sendCurrentState();
  };
}
